import React, { useEffect, useState } from "react";
import { Hidden } from "@material-ui/core";
import { ScrollPanel } from "primereact/scrollpanel";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { useSelector } from "react-redux";
import LoadingComponent from "../../lib/LoadingComponent";
import { getBizName, getLogo, getStyle } from "../../libs/todoSlice";
import fontColor from "../../lib/fontColor";

/**
 * โครงหน้า Register ที่ใช้ร่วมกัน (โลโก้ + การ์ด + ปุ่ม + snackbar)
 * children = ฟิลด์ของแต่ละหน้า
 */
function RegisterShell({
  children,
  onCancel,
  onSubmit,
  submitDisabled,
  loading,
  snackbarOpen,
  onCloseSnackbar,
}) {
  const logo = useSelector(getLogo);
  const business_name = useSelector(getBizName);
  const style = useSelector(getStyle);

  const [devicePixelRatio, setDevicePixelRatio] = useState();

  useEffect(() => {
    const handleResize = () => setDevicePixelRatio(window.devicePixelRatio);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        background: "#F8F9FA",
        height: "100vh",
        overflow: "auto",
      }}
    >
      <div style={{ padding: "30px 80px 0 80px", marginBottom: "50px" }}>
        <img
          src={`data:image/png;base64, ${logo}`}
          alt=""
          onError={({ target }) => {
            target.src = "/one-platform.png";
          }}
          style={{
            maxHeight: "60px",
            maxWidth: "60px",
          }}
        />
        <span
          style={{
            fontWeight: "600",
            color: "#000",
            padding: "10px",
          }}
        >
          {business_name}
        </span>
      </div>
      <Hidden xsDown>
        <div style={{ display: "flex", justifyContent: "right" }}>
          <img
            src="/img_create_path.png"
            style={{
              position: "fixed",
              width: "670.75px",
              height: "650.54px",
              top: "110px",
            }}
            alt=""
          />
        </div>
      </Hidden>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "10px 40px",
        }}
      >
        <div style={{ zIndex: "1" }}>
          <Card
            style={{
              width: "80vw",
              height: "100%",
              maxHeight: devicePixelRatio == "1" ? "820px" : "600px",
              background: "rgba(0, 0, 0, 0.2)",
              borderRadius: "32px",
              padding: "15px 40px",
              color: "#053075",
              overflow: "auto",
            }}
          >
            <span
              style={{
                display: "flex",
                justifyContent: "center",
                fontWeight: "700",
                fontSize: "22px",
                lineHeight: "50px",
                letterSpacing: "0.02em",
                paddingBottom: "10px",
              }}
            >
              ลงทะเบียนผู้ใช้งานใหม่
            </span>
            <div className="card-croll-panel">
              <ScrollPanel
                style={{
                  width: "100%",
                  height: devicePixelRatio == "1" ? "600px" : "400px",
                  backgroundColor: "#ffffff33",
                  borderRadius: "10px",
                  padding: "20px",
                  paddingBottom: "0px",
                }}
              >
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: "400",
                    lineHeight: "21px",
                    letterSpacing: "0.02em",
                  }}
                >
                  {children}
                </span>
              </ScrollPanel>
            </div>

            <div
              style={{
                marginTop: "25px",
                marginBottom: "20px",
                display: "flex",
                gap: "12px",
                justifyContent: "center",
                padding: "0 4px",
              }}
            >
              <Button
                variant="outlined"
                style={{
                  flex: 1,
                  maxWidth: "200px",
                  minHeight: "44px",
                  padding: "10px 12px",
                  color: "#053075",
                  borderRadius: "6px",
                  border: "1px solid #053075",
                  whiteSpace: "normal",
                  lineHeight: 1.4,
                  wordBreak: "keep-all",
                }}
                onClick={onCancel}
              >
                ยกเลิก
              </Button>

              <Button
                sx={{
                  flex: 1,
                  maxWidth: "200px",
                  minHeight: "44px",
                  padding: "10px 12px",
                  borderRadius: 1,
                  color: fontColor(style.secondary_color),
                  background: style.secondary_color,
                  whiteSpace: "normal",
                  lineHeight: 1.4,
                  wordBreak: "keep-all",
                }}
                disabled={submitDisabled}
                onClick={onSubmit}
              >
                {loading ? <LoadingComponent width={50} height={50} /> : "ลงทะเบียน"}
              </Button>
            </div>
          </Card>
        </div>
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={onCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert variant="filled" severity="error" sx={{ width: "100%" }}>
          กรุณากรอกข้อมูลให้ครบถ้วน
        </Alert>
      </Snackbar>
    </div>
  );
}

export default RegisterShell;